// Product and SKU names come from GitHub's billing report as raw ids ("code_quality", "actions_linux"). The page shows
// readable names instead; the raw id is still what is sent to the API and stays in the URL. Products and SKUs aren't a
// fixed list, so anything not named here is made readable automatically rather than shown raw.

const PRODUCT_LABELS = {
  actions: "Actions",
  codespaces: "Codespaces",
  code_quality: "Code Quality",
  copilot: "Copilot",
  ghas: "GitHub Advanced Security",
  git_lfs: "Git LFS",
  models: "GitHub Models",
  packages: "Packages",
};

const SKU_LABELS = {
  copilot_ai_credit: "AI Credits",
  copilot_for_business: "Copilot Business license",
  actions_linux: "Linux",
  actions_windows: "Windows",
  actions_macos: "macOS",
  codespaces_compute: "Compute",
  codespaces_storage: "Storage",
  packages_bandwidth: "Bandwidth",
  lfs_storage: "Storage",
  lfs_bandwidth: "Bandwidth",
};

// Words that shouldn't just be title-cased.
const WORDS = {
  ai: "AI",
  api: "API",
  ci: "CI",
  cpu: "CPU",
  gb: "GB",
  ghas: "GHAS",
  gpu: "GPU",
  ide: "IDE",
  lfs: "LFS",
  macos: "macOS",
  pr: "PR",
  ram: "RAM",
  vcpu: "vCPU",
};

const prettify = (raw) =>
  String(raw)
    .split(/[_\-\s]+/)
    .filter(Boolean)
    .map((word) => WORDS[word.toLowerCase()] ?? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");

export const productLabel = (product) => {
  if (!product) return "";
  return PRODUCT_LABELS[product] ?? prettify(product);
};

// SKUs are always shown under (or beside) their product, so a repeated product prefix is dropped:
// "actions_linux" under Actions reads "Linux".
export const skuLabel = (sku, product) => {
  if (!sku) return "";
  if (SKU_LABELS[sku]) return SKU_LABELS[sku];
  const prefix = product ? `${product}_` : null;
  const stripped = prefix && sku.startsWith(prefix) && sku.length > prefix.length ? sku.slice(prefix.length) : sku;
  return prettify(stripped);
};
